import React from 'react'
import { GetTagInstructionsContainer, CodeBlock } from './Instructions.styled'
import { useTranslation } from 'react-i18next'
import { BulletLine } from '../elements/BulletLine'
import { CopyTextButton } from '@clickcease/cc-client-components-lib'
import * as codeFunctions from './utils'

export const DiyScriptMethod = ({
  tagUrl,
  domainHashCode,
}: {
  tagUrl: string
  domainHashCode: string
}) => {
  const { t } = useTranslation('domainManagement')
  const code = codeFunctions.generateCodeScript(tagUrl, domainHashCode)
  const bodyCode = codeFunctions.generateNoScriptCode(tagUrl, domainHashCode)

  return (
    <GetTagInstructionsContainer>
      <BulletLine
        underBullet={
          <>
            <CodeBlock>{code}</CodeBlock>
            <CopyTextButton value={code} buttonText={t('get_tag_modal.copy-code')} />
          </>
        }
      >
        {t('get_tag_modal.self_tag_steps.step_1')}
      </BulletLine>
      <BulletLine
        underBullet={
          <>
            <CodeBlock>{bodyCode}</CodeBlock>
            <CopyTextButton value={bodyCode} buttonText={t('get_tag_modal.copy-code')} />
          </>
        }
      >
        {t('get_tag_modal.self_tag_steps.step_2')}
      </BulletLine>
    </GetTagInstructionsContainer>
  )
}
